<template>
	<v-dialog v-model="dialog" persistent max-width="600px">
		<v-card>
			<v-toolbar flat dense cad>
				<v-toolbar-title class="subheading">Edit Answer</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-divider></v-divider>
			<v-card-text>
				<div>
					<div
						class="result-container"
						:class="{
							'item-text': true,
							'na-text': form.result == '-1',
							'green-text': form.result == '2',
							'amber-text': form.result == '1',
							'red-text': form.result == '0'
						}"
					>
						<table role="presentation">
							<tr>
								<td style="width: 1px">
									<v-menu transition="scale-transition" lazy right absolute offset-y :disabled="isUpdatingItem">
										<v-btn v-if="form.item.rankType === 1" slot="activator" :class="{ 'item-btn': true, success: form.result == '2', warning: form.result == '1', error: form.result == '0', disabled: isUpdatingItem }" fab small>
											<v-icon v-if="form.result != '-1'" style="font-size: 14px">{{ getIcon(form.result) }}</v-icon>
											<span v-if="form.result == '-1'" style="font-size: 9px">n/a</span>
										</v-btn>

										<div class="traffic-light-options-container">
											<v-btn :title="greenDescription" color="#4caf50" fab small dark class="traffic-light-option" @click="onRateItem(2)"> </v-btn>
											<v-btn :title="amberDescription" color="#ffc107" fab small dark class="traffic-light-option" @click="onRateItem(1)"> </v-btn>
											<v-btn :title="redDescription" color="#f44336" fab small dark class="traffic-light-option" @click="onRateItem(0)"> </v-btn>
											<v-btn :title="naDescription" small class="traffic-light-option" @click="onRateItem(-1)">N/A</v-btn>
										</div>
									</v-menu>
								</td>

								<td>{{ form.item.item }}</td>
							</tr>
						</table>
					</div>

					<div v-for="outcome in form.outcomes" :key="outcome.id" class="outcome-container">
						<div
							class="result-container"
							:class="{
								'item-text': true,
								'na-text': outcome.result == '-1',
								'green-text': outcome.result == '2',
								'amber-text': outcome.result == '1',
								'red-text': outcome.result == '0'
							}"
						>
							<table role="presentation">
								<tr>
									<td style="width: 1px">
										<v-menu transition="scale-transition" lazy right absolute offset-y :disabled="isUpdatingItem">
											<v-btn slot="activator" :class="{ 'item-btn': true, success: outcome.result == '2', warning: outcome.result == '1', error: outcome.result == '0', disabled: isUpdatingItem }" fab small>
												<v-icon v-if="outcome.result != '-1'" style="font-size: 14px">{{ getIcon(outcome.result) }}</v-icon>
												<span v-if="outcome.result == '-1'" style="font-size: 9px">n/a</span>
											</v-btn>

											<div class="traffic-light-options-container">
												<v-btn :title="greenDescription" color="#4caf50" fab small dark class="traffic-light-option" @click="onRateItemOutcome(outcome.id, 2)"> </v-btn>
												<v-btn :title="amberDescription" color="#ffc107" fab small dark class="traffic-light-option" @click="onRateItemOutcome(outcome.id, 1)"> </v-btn>
												<v-btn :title="redDescription" color="#f44336" fab small dark class="traffic-light-option" @click="onRateItemOutcome(outcome.id, 0)"> </v-btn>
												<v-btn :title="naDescription" small class="traffic-light-option" @click="onRateItemOutcome(outcome.id, -1)">N/A</v-btn>
											</div>
										</v-menu>
									</td>

									<td>{{ outcome.outcome.outcome }}</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
				<div class="mt-3">
					<v-textarea v-model="form.comment" rows="2" required box auto-grow label="Comments"></v-textarea>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="closeEditor">Cancel</v-btn>

				<v-btn color="primary" flat :loading="isUpdatingItem" :disabled="isUpdatingItem" @click="submit">
					Update
					<span slot="loader">Saving...</span>
				</v-btn>

			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import trafficLightsMixin from '@/mixins/trafficLightsMixin';

	export default {
		mixins: [trafficLightsMixin],
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			item: {
				type: Object,
				required: true
			},
			isUpdatingItem: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form: {}
			};
		},
        created() {
            this.form = JSON.parse(JSON.stringify(this.item));
        },
		methods: {
			submit() {
                this.$emit('save', {
                    id: this.form.id,
					result: this.form.result,
					comment: this.form.comment,
					outcomes: this.form.outcomes.map(x => ({
						id: x.id,
						result: x.result
					}))
                });
            },
			closeEditor() {
				this.$emit('closeEditor');
			},
			onRateItemOutcome(outcomeId, result) {
                const foundIndex = this.item.outcomes.findIndex(x => x.id === outcomeId);
                if (foundIndex > -1) {
                    const newVal = {...this.form.outcomes[foundIndex], result};
                    this.form.outcomes.splice(foundIndex, 1, newVal);
                }
            },
			onRateItem(result) {
				this.form.result = result;
            },
			getIcon(result) {
				switch (result) {
					case -1:
						return 'radio_button_unchecked';
					case 0:
						return 'clear';
					case 1:
						return 'remove';
					case 2:
						return 'check';
					default:
						return 'keyboard_arrow_right';
				}
			}
		}
	};
</script>

<style scoped>
	.result-container {
		border-left-color: lightgray;
		padding-left: 10px;
		padding-right: 10px;
	}
	.outcome-container {
		margin-left: 20px;
	}
	.traffic-light-options-container {
		padding: 5px;
		background-color: #fff;
	}
	.traffic-light-option {
		height: 30px;
		width: 30px;
	}
</style>